import { parse } from 'date-fns';
export const getAge = (dob, at) => {
  const atDate = parse(at, 'yyyy-MM-dd', new Date());
  const dobDate = parse(dob, 'yyyy-MM-dd', new Date());
  const age = atDate.getFullYear() - dobDate.getFullYear();
  const m = atDate.getMonth() - dobDate.getMonth();
  if (m < 0 || m === 0 && atDate.getDate() < dobDate.getDate()) {
    return age - 1;
  }
  return age;
};